"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
exports.__esModule = true;
var chaosnet_1 = __importDefault(require("./src/networks/chaosnet"));
var devnet_1 = __importDefault(require("./src/networks/devnet"));
var localnet_1 = __importDefault(require("./src/networks/localnet"));
var mainnet_1 = __importDefault(require("./src/networks/mainnet"));
var testnet_1 = __importDefault(require("./src/networks/testnet"));
exports.renMainnet = mainnet_1["default"];
exports.renChaosnet = chaosnet_1["default"];
exports.renTestnet = testnet_1["default"];
exports.renDevnet = devnet_1["default"];
exports.renLocalnet = localnet_1["default"];
var RenNetwork;
(function (RenNetwork) {
    RenNetwork["Mainnet"] = "mainnet";
    RenNetwork["Chaosnet"] = "chaosnet";
    RenNetwork["Testnet"] = "testnet";
    RenNetwork["Devnet"] = "devnet";
    RenNetwork["Localnet"] = "localnet";
})(RenNetwork = exports.RenNetwork || (exports.RenNetwork = {}));
exports.RenNetworks = (_a = {},
    _a[RenNetwork.Mainnet] = exports.renMainnet,
    _a[RenNetwork.Chaosnet] = exports.renChaosnet,
    _a[RenNetwork.Testnet] = exports.renTestnet,
    _a[RenNetwork.Devnet] = exports.renDevnet,
    _a[RenNetwork.Localnet] = exports.renLocalnet,
    _a);
